export default __webpack_public_path__ + "static/media/authorization.f8bd396c.svg";